import { v4 as uuidv4 } from 'uuid'
import useTranslation from 'next-translate/useTranslation'
import { useDispatch, useSelector } from 'react-redux'
import { useState } from 'react'
import useTransactions from 'tennders-transactions/hooks/useTransactions'
import {
  dispatchCounterMode, dispatchOfferErrors,
  dispatchOfferingToLoad,
  dispatchOfferingToMatch,
  dispatchOfferingToTruck,
  dispatchOfferReset,
  dispatchShowRouteOf
} from 'tennders-market/offer/stores/action'
import { apiGet, apiPost, apiPut } from 'tennders-stracture/libs/api'
import useSocket from 'tennders-common/hooks/useSocket'
import { useToast } from 'tennders-common/hooks/useToast'
import useTransaction from 'tennders-transactions/hooks/useTransaction'
import useInputScroll from 'tennders-common/hooks/useInputScroll'
import useSession from 'tennders-auth/hooks/useSession'

const useOffer = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const { refreshTransaction } = useTransactions()
  const { isBroker } = useSession()
  const { setRefresh } = useSocket()
  const selectedOffer = useSelector((state) => state.offer.selectedOffer)
  const counterMode = useSelector((state) => state.offer.counterMode)
  const errors = useSelector((state) => state.offer.offerErrors)
  const showRouteOf = useSelector((state) => state.offer.showRouteOf)
  const offeringToLoad = useSelector((state) => state.offer.offeringToLoad)
  const offeringToTruck = useSelector((state) => state.offer.offeringToTruck)
  const offeringToMatch = useSelector((state) => state.offer.offeringToMatch)
  const [savingRoute, setsavingRoute] = useState(false)
  const { scrollToFirstError } = useInputScroll()
  const {
    toastError,
    toastSuccess
  } = useToast()
  const setOfferErrors = (errors) => dispatch(dispatchOfferErrors(errors))
  const setCounterMode = (mode) => dispatch(dispatchCounterMode(mode))
  const setShowRouteOf = (transaction) => dispatch(dispatchShowRouteOf(transaction))
  const setOfferingToLoad = (transaction) => dispatch(dispatchOfferingToLoad(transaction))
  const { setTransaction } = useTransaction()

  const setOfferingToTruck = (transaction) => dispatch(dispatchOfferingToTruck(transaction))

  const setOfferingToMatch = (transaction) => dispatch(dispatchOfferingToMatch(transaction))

  const triggerFirstOffer = (transaction) => {
    setTransaction(transaction)
  }

  const resetOffer = () => dispatch(dispatchOfferReset())

  const getOfferDetail = async (id) => apiGet(`offers/${id}`)

  const trackOffer = async (id) => apiGet(`offers/${id}/track`)

  const makeOffer = async (transaction, form) => {
    const {
      saveCallback,
      ...rest
    } = form
    setOfferErrors({})
    const selectedRouteId = uuidv4()
    const toSave = { ...rest }

    // compress callback changed to save callback
    // which automatically compresses and send to the backend server
    if (saveCallback && !toSave.selectedRouteId) {
      setsavingRoute(true)
      toSave.selectedRouteId = selectedRouteId
      await saveCallback(selectedRouteId)
      setsavingRoute(false)
    }

    const response = await apiPost('offers', {
      ...toSave,
      bid: form.bid,
      transaction: transaction.id
    })

    if (response.errors) {
      setOfferErrors(response.errors)
      toastError(t('toast:checkErrors'))
      scrollToFirstError()
      return response
    }

    /* if (!isBroker()) {
     toastSuccess('Congrats, You can track negations from My Bids page')
    } */

    setCounterMode(false)
    // setRefresh('all');
    // resetOffer();

    /*
    if (user?.id === transaction?.createdBy?.id) {
      setRefresh('transaction');
    } else if (transaction?.matchedLoad) {
      setRefresh('load');
    } else {
      setRefresh('truck');
    }

    fetchPrompts(); */
    return response
  }

  const acceptOffer = async (offerId) => {
    await apiPut(`offers/${offerId}/accept`, {})
    setCounterMode(false)
    setRefresh('offers')
    setRefresh('all')
  }

  const rejectOffer = async (offerId) => {
    await apiPut(`offers/${offerId}/reject`, {})
    setCounterMode(false)
    refreshTransaction()
    setRefresh('all')
  }

  const confirmDeal = async (offerId) => {
    await apiPut(`offers/${offerId}/confirm-deal`, {})
    setCounterMode(false)
    setRefresh('offers')
    setRefresh('all')
  }

  const rejectDeal = async (offerId) => apiPut(`offers/${offerId}/reject-deal`, {})

  const revertBidding = async (offerId) => apiPut(`offers/${offerId}/revert-bidding`)

  return {
    triggerFirstOffer,
    selectedOffer,
    makeOffer,
    showRouteOf,
    setShowRouteOf,
    errors,
    setOfferErrors,
    counterMode,
    acceptOffer,
    rejectOffer,
    confirmDeal,
    rejectDeal,
    resetOffer,
    savingRoute,
    revertBidding,
    getOfferDetail,
    setCounterMode,
    setOfferingToLoad,
    setOfferingToTruck,
    setOfferingToMatch,
    offeringToLoad,
    offeringToTruck,
    offeringToMatch,
    trackOffer
  }
}

export default useOffer
